import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const StyledButton = styled.button`
  position: relative;
  cursor: pointer;
  -webkit-appearance: none;
  display: inline-block;
  padding: 8px 12px;
  font-weight: 600;
  text-decoration: none;
  outline: 0;
  text-align: center;
  box-sizing: border-box;
  border: none;
  color: ${(props) => (props.colorscheme === 'white' ? '#31383C' : '#FFFFFF')};
  text-shadow: ${(props) =>
    props.colorscheme !== 'white'
      ? '0px 1px 0.5px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.05)'
      : 'none'};
  border-radius: 8px;
  height: 36px;
  line-height: 20px;
  font-size: 0.85rem;
  width: ${(props) => (props.stretched ? '100%' : 'auto')};
  transition: all ease-in-out 0.1s;

  /* Default Blue variant */
  background-color: rgba(25, 164, 243, 1);
  background: linear-gradient(
    180deg,
    0% rgba(255, 255, 255, 0.12),
    100% rgba(255, 255, 255, 0)
  );
  box-shadow:
    0 1px 1px 0 rgba(0, 0, 0, 0.04),
    0 1px 2px 0 rgba(0, 0, 0, 0.03),
    0 2px 3px 0 rgba(0, 0, 0, 0.03),
    0 -1px 0 0 inset rgba(0, 0, 0, 0.04),
    0 -1px 2px 0 inset rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: #36b4fa;
  }

  /* White variant */
  ${(props) =>
    props.colorscheme === 'white' &&
    `
    background-color: #ffffff;
    background: #ffffff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 1px 1px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 2px 3px 0 rgba(0, 0, 0, 0.03);

    &:hover {
      background-color: #FAFAFA;
      background: #FAFAFA;
    }
  `}

  /* Blue variant (explicit) */
  ${(props) =>
    props.colorscheme === 'blue' &&
    `
    background-color: rgba(25, 164, 243, 1);
    background: linear-gradient(180deg, 0% rgba(255, 255, 255, 0.12), 100% rgba(255, 255, 255, 0));
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 2px 3px 0 rgba(0, 0, 0, 0.03), 0 -1px 0 0 inset rgba(0, 0, 0, 0.04), 0 -1px 2px 0 inset rgba(0, 0, 0, 0.05);
  `}

  /* Green variant */
  ${(props) =>
    props.colorscheme === 'green' &&
    `
    background-color: rgba(119, 201, 53, 1);
    background: linear-gradient(180deg, 0% rgba(255, 255, 255, 0.12), 100% rgba(255, 255, 255, 0));
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 2px 3px 0 rgba(0, 0, 0, 0.03), 0 -1px 0 0 inset rgba(0, 0, 0, 0.04), 0 -1px 2px 0 inset rgba(0, 0, 0, 0.05);

    &:hover {
      background-color: #89ce4d;
    }
  `}

  svg {
    vertical-align: middle;
  }

  &.setapp-button:hover {
    background-color: #393941 !important;
  }

  &:disabled {
    opacity: 0.7;
    pointer-events: none;
  }

  .spinner {
    animation: rotate 2s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
    width: 32px;
    height: 32px;

    & .path {
      stroke: #fff;
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`

const Button = (props) => {
  let showSpinner

  if (props.showprogress) {
    showSpinner = true
  } else {
    showSpinner = false
  }

  return (
    <motion.div style={{ display: props.stretched ? 'block' : 'inline-block' }}>
      <StyledButton {...props}>
        {showSpinner && (
          <svg className="spinner" viewBox="0 0 50 50">
            <circle
              className="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="5"></circle>
          </svg>
        )}

        {!showSpinner && props.children}
      </StyledButton>
    </motion.div>
  )
}

export default Button
